import React, { Component } from 'react'

export default class Menu extends Component {
    render() {
        return(
            <div>
                <div>
                    <nav href="#navbar" className="js-colorlib-nav-toggle colorlib-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar"></nav>
                    <aside id="colorlib-aside" className="border js-fullheight">
                        <div className="text-center">
                            <div className="author-img" style={{backgroundImage: 'url(images/about.JPG)'}}/>
                            <h1 id="colorlib-logo"><a href="index.html">Fernando Winardi</a></h1>
                            <span className="email"><i className="icon-mail"/>f.winardi@gmail.com</span>
                        </div>
                        <nav id="colorlib-main-menu" role="navigation" className="navbar">
                            <div id="navbar" className="collapse">
                                <ul>
                                    <li className="active"><a href="#home" data-nav-section="home">Home</a></li>
                                    <li><a href="#about" data-nav-section="about">About</a></li>
                                    <li><a href="#timeline" data-nav-section="timeline">Timeline</a></li>
                                </ul>
                            </div>
                        </nav>
                        <nav id="colorlib-main-menu">
                            <ul>
                                <li><a href="https://www.facebook.com/fernando.oei/" target="_blank" rel="noopener noreferrer"><i className="icon-facebook2"/></a></li>
                                <li><a href="https://twitter.com/f_stardust" target="_blank" rel="noopener noreferrer"><i className="icon-twitter2" /></a></li>
                                <li><a href="https://www.instagram.com/fernandowinardi/" target="_blank" rel="noopener noreferrer"><i className="icon-instagram" /></a></li>
                                <li><a href="https://www.linkedin.com/in/fernando-winardi/" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin2" /></a></li>
                                <li><a href="https://github.com/fernandowinardi" target="_blank" rel="noopener noreferrer"><i className="icon-github"></i></a></li>
                            </ul>
                        </nav>
                        <div className="colorlib-footer">
                            <p><small>Feel free to email me and we can talk about anything!</small></p>
                            <p><small>OR</small></p>
                            <span className="whatsapp"><i className="icon-whatsapp"/> :  +62811648080</span>
                        </div>
                    </aside>
                </div>
            </div>
        )
    }
}